import React from 'react';
import { useCalendarContext } from '../Provider';
import Dropdown from '../../../Components/Dropdown';
import { useJob } from '../../../Data/Jobs';
import { getTitle } from '../../../Components/Formatting/Customer/Title';
import Button from '../../../Components/Button/Button';
import ButtonRow from '../../../Components/Button/ButtonRow';

const DayHeaderView = ({day, appointments, scheduledWithoutAppointments}) => {
    const {isCalendarLoading, dayWidth, setConfirming, setJobWithoutAppointment, setCompleting, setReplanningDay, headerExpanded} = useCalendarContext();

    return <div className="shrink-0 p-3 relative" style={{width: dayWidth}}>
        <h3 className="text-lg font-bold text-brand text-center">
            {day.title}
        </h3>
        <div className="absolute right-3 top-2">
            <Dropdown flush
                btnClassnames="bg-white/80 border"
                options={[
                    {
                        title: `Confirm schedule`,
                        icon: 'CalendarCheck',
                        onClick: () => setConfirming({day}),
                        disabled: !appointments?.length
                    },
                    {
                        title: `Mark jobs as done`,
                        icon: 'Check',
                        onClick: () => setCompleting({day}),
                        disabled: !appointments?.length
                    },
                    {
                        title: 'Replan day',
                        icon: 'Route',
                        onClick: () => setReplanningDay(day),
                    }
                ]}
            />
        </div>

        {headerExpanded && <Inner {...{
            isCalendarLoading,
            scheduledWithoutAppointments,
            setJobWithoutAppointment,
            replanDay: () => setReplanningDay(day)
        }} />}
    </div>
}

const Inner = ({isCalendarLoading, scheduledWithoutAppointments, setJobWithoutAppointment, replanDay}) => {
    if (isCalendarLoading) {
        return null;
    }

    if (!scheduledWithoutAppointments?.length) {
        return <p className="text-center text-muted text-sm py-2">
            No jobs without times
        </p>
    }

    return <>
        <ScheduledWithoutAppointments
            jobIds={scheduledWithoutAppointments}
            setJobWithoutAppointment={setJobWithoutAppointment}
        />
        <ButtonRow arrange="center">
            <Button theme="light" label="Replan day" icon="Route" onClick={replanDay} className="mt-3" zeroMargin />
        </ButtonRow>
    </>
}

const ScheduledWithoutAppointments = ({jobIds, setJobWithoutAppointment}) => {
    return <div className="flex flex-col gap-2 mt-3 max-h-[50vh] overflow-x-auto">
        {jobIds.map((jobId) => <Job key={jobId}
            jobId={jobId}
            // job={findJob(jobId)}
            setJobWithoutAppointment={setJobWithoutAppointment}
        />)}
    </div>
}

const Job = ({jobId, setJobWithoutAppointment}) => {
    const {job} = useJob(jobId, false);

    return <div
        onClick={() => setJobWithoutAppointment(job)}
        className="rounded-lg w-full overflow-hidden shadow-md py-0 px-2 bg-gray-200 border border-gray-300 shrink-0 cursor-pointer"
    >
        {job ? getTitle(job.customer) ?? 'No customer name' : <>&nbsp;</>}
    </div>
}

export default DayHeaderView;